import React from 'react';
import clsx from 'clsx';
import i18n from 'i18n-js';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { dateTimeIgnoreTimezone, formatDate } from 'helpers/datetimeHelper';
import { formatPickupTimeslot, isPickupDateToday } from 'helpers/orderInAdvanceHelper';

interface PickupTimeslotTagProps {
    pickupTimeslot?: { from: number; to: number } | null;
    pickupDate?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        pickupSlotTag: {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.primary.dark,
            borderRadius: 4,
            padding: '2px 6px',
            fontSize: 11,
            fontWeight: 700,
            lineHeight: '16px',
        },
        pickupSlotTagFuture: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
        },
    })
);

export default function PickupTimeslotTag({ pickupTimeslot, pickupDate }: PickupTimeslotTagProps) {
    const classes = useStyles();
    if (!pickupTimeslot) {
        return null;
    }

    const isFuturePickup = !!pickupDate && !isPickupDateToday(pickupDate);
    const pickupDateLabel = isFuturePickup
        ? formatDate(dateTimeIgnoreTimezone(pickupDate!))
        : pickupDate
        ? i18n.t('orders.pickupToday')
        : i18n.t('orders.nextWorkday');

    return (
        <span
            className={clsx(classes.pickupSlotTag, {
                [classes.pickupSlotTagFuture]: isFuturePickup,
            })}
        >
            {`${pickupDateLabel}, ${formatPickupTimeslot(pickupTimeslot)}`}
        </span>
    );
}
